export enum QueryKeys {
  COMMODITIES = 'commodities',
}
